import React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import AddProfile from "./AddProfile/AddProfile";
import IndexPage from "../../../../Dashboard/Components/SecuritySettings/SecurityProfiles/index";
import EditProfile from "./EditProfile/EditProfile";

const SecurityProfilesRoutes = (props) => {
  return (
    <BrowserRouter basename="/home/securityProfiles">
      <Switch>
        <Route path="/addProfile">
          <AddProfile LangData={props.LangData} />
        </Route>
        <Route path="/editProfile">
          <EditProfile LangData={props.LangData} />
        </Route>
        <Route path="/" exact>
          <IndexPage LangData={props.LangData} />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
export default SecurityProfilesRoutes;
